import _get from 'lodash/get';

import INITIAL_STATE from './initialState';

export const setFeatureFlagSuccess = (state, action) => ({
    ...state,
    isPackagingEnabled: _get(action, 'payload.isPackagingEnabled'),
});

/**
 * Reducer helper for catching the auth logout action.
 *
 * @method logoutSuccess
 * @return {Object}      The updated state
 */
export const logoutSuccess = () => INITIAL_STATE;
